export default "__VITE_ASSET__BUK6M4TC__"